import React from 'react'

import { CcChipsEditor } from './CcChipsEditor'
import { deriveRecurringLabels } from './helpers'
import type { DealDraft } from './types'

interface RecurringCardProps {
  draft: DealDraft
  patch: (next: Partial<DealDraft>) => void
}

export const RecurringCard: React.FunctionComponent<RecurringCardProps> = (props) => {
  const { draft, patch } = props
  const labels = deriveRecurringLabels(draft.activationISO, draft.billingType)

  return (
    <div className="recurring-card">
      <div className="recurring-title">Recurring Billing</div>
      <div className="recurring-row no-toggle">
        <span className="recurring-label">Billing Day</span>
        <span className="recurring-value">{labels.billingDay}</span>
      </div>
      <div className="recurring-row no-toggle">
        <span className="recurring-label">Next Invoice</span>
        <span className="recurring-value">{labels.nextInvoice}</span>
      </div>
      <div className="recurring-row">
        <span className="recurring-label">
          Auto-send
          {draft.autoSendOn && <span style={{ color: 'var(--danger)' }}> *</span>}
        </span>
        <label className="toggle">
          <input
            type="checkbox"
            checked={draft.autoSendOn}
            onChange={(event) => patch({ autoSendOn: event.target.checked })}
          />
          <span className="toggle-slider" />
        </label>
        <div
          className="recurring-content"
          style={{ flexDirection: 'column', alignItems: 'stretch', gap: 6 }}
        >
          <input
            className="form-input readonly"
            type="email"
            placeholder="customer@company.com"
            style={{ width: '100%' }}
            value={draft.customerEmail}
            readOnly
            tabIndex={-1}
          />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              fontSize: 11,
              color: '#6e6e73',
            }}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              width={11}
              height={11}
              style={{ flexShrink: 0 }}
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 16v-4" />
              <path d="M12 8h.01" />
            </svg>
            <span>Mirrors Customer Email · sent 1 month before expiration</span>
          </div>
        </div>
      </div>
      <div className="recurring-row">
        <span className="recurring-label">
          CC Account Exec
          {draft.ccExecOn && <span style={{ color: 'var(--danger)' }}> *</span>}
        </span>
        <label className="toggle">
          <input
            type="checkbox"
            checked={draft.ccExecOn}
            onChange={(event) => patch({ ccExecOn: event.target.checked })}
          />
          <span className="toggle-slider" />
        </label>
        <CcChipsEditor
          value={draft.ccExecs}
          onChange={(ccExecs) => patch({ ccExecs })}
          disabled={!draft.ccExecOn}
        />
      </div>
    </div>
  )
}
